import useOKTAUserStore, { OKTAUserType } from "@app/store/useOKTAUserStore";
import { BAASV3Response } from "@typings/MyBH";

import fetchBHApi from "./fetchBHApi";
import { isArrayWithElements } from "./utils";

/**
 * Checking the Current User Login type
 * @param userInfo OKTA user Info
 * @returns return true or false based on login
 */
export function checkAllowedUserType(userInfo: OKTAUserType) {
  const allowedUserTypes = ["y-sub", "y-reg"] as const;

  return (
    userInfo?.usertype &&
    allowedUserTypes.includes(
      userInfo.usertype as (typeof allowedUserTypes)[number],
    )
  );
}

/**
 * Get the Loged in User Info
 * @returns Based on the user login return the requieed parameter.
 */
export function GetUserInfo() {
  /**
   * isUserLoading for after suceesfull mysph login success
   * userInfo Mysph userInfo
   */
  const { isUserLoading, userInfo } = useOKTAUserStore();

  const visitorId = !isUserLoading ? (userInfo?.mysphw as string) : "";

  const isReady = !isUserLoading && Boolean(visitorId);

  return {
    visitorId: isReady ? visitorId : "",
    userInfo: isReady ? userInfo : "",
    isUserLoading: !isReady,
  };
}

/**
 * Onlcick handler for Follow Topic
 * @param tagId Tag Unique Id
 * @param visitorId User VisitorId
 * @param tagName Tag Name
 * @param setFollowed UseState function for the update the UserFollowdState
 * @param updateMystData Function to update MyST data
 */
export async function HandleFollowTopic(
  tagId: string,
  visitorId: string,
  tagName: string,
  setFollowed: React.Dispatch<React.SetStateAction<boolean>>,
  updateMybhData?: (visitorId: string) => Promise<void>,
) {
  try {
    if (visitorId && tagId && tagName) {
      const response = await fetchBHApi<BAASV3Response>(
        "baasAddFollowTags",
        "GET",
        {},
        {
          tagId: tagId,
          visitorID: visitorId,
          tagName: tagName,
        },
      );

      const isSuccess = response.code === 200 && Boolean(response.success);

      setFollowed(isSuccess);
      void updateMybhData?.(visitorId);
    }
  } catch (error) {
    console.error("BAAS:: V3 follow topic api failed", {
      error,
    });
  }
}

/**
 * OnClick handler for Unfollow topic
 * @param tagId Tag Unique Id
 * @param visitorId User VisitorId
 * @param tagName Tag Name
 * @param setFollowed UseState function for the update the UserFollowdState
 * @param updateMystData Function to update MyST data
 */
export async function HandleUnFollowTopic(
  tagId: string,
  visitorId: string,
  tagName: string,
  setFollowed: React.Dispatch<React.SetStateAction<boolean>>,
  updateMybhData?: (visitorId: string) => Promise<void>,
) {
  try {
    if (visitorId && tagId && tagName) {
      const response = await fetchBHApi<BAASV3Response>(
        "baasRemoveFollowTags",
        "GET",
        {},
        {
          tagId: tagId,
          visitorID: visitorId,
          tagName: tagName,
        },
      );
      if (response.code === 200 && response.success) {
        setFollowed(false);
        updateMybhData && void updateMybhData(visitorId);
      }
    }
  } catch (error) {
    console.error("BAAS:: V3 unfollow topic api failed", {
      error,
    });
  }
}

/**
 * Filter the CUEID form bAAS v3 response.
 * @param data Baas V3 array response for tags and author
 * @returns filtered cueId
 */
export function formatFollowResponse(data: { cueId: string; name: string }[]) {
  if (isArrayWithElements(data)) {
    const filteredData: string[] = data.map((data) => data.cueId);
    return filteredData;
  } else {
    return [];
  }
}
